const O = 6, N = -1;
export {
  N as NO_ACTIVE_OPTION,
  O as OPTIONS_MAX_LENGTH
};
